/**
 * Public onboarding routes.
 *
 * These are the only surfaces that render for anonymous visitors without being
 * redirected to sign in (portal-first applies to everything else). They are
 * detected before the authenticated app boots (see main.tsx) and served by a
 * separate, self-contained React tree (PublicApp), so react-admin's `requireAuth`
 * gate never applies to them.
 */

/** Paths, relative to the app base (`import.meta.env.BASE_URL`). */
export const PUBLIC_ONBOARDING_PATHS = [
  '/signup',
  '/payment/confirming',
  '/invite-user',
  '/invite-existing-user',
] as const;

/** The app base without its trailing slash (`''` in dev, `/admin` in prod). */
export function appBase(): string {
  return (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
}

/** Current pathname relative to the app base. */
function relativePath(): string {
  const base = appBase();
  const path = window.location.pathname;
  if (base && path.startsWith(base)) {
    return path.slice(base.length) || '/';
  }
  return path;
}

/** Whether the current location is one of the public onboarding routes. */
export function isPublicOnboardingRoute(): boolean {
  const rel = relativePath();
  return PUBLIC_ONBOARDING_PATHS.some((p) => rel === p);
}
